import * as UI from 'ui'
import * as Displays from 'support/displays'
import { Translation } from '@morningtrain/react-translations'
import React from 'react'
import { WhenModelValue } from '@morningtrain/react-resources'

export default function CardSummarySection () {
  const condition = val => val !== null && typeof val !== 'undefined'

  return (
    <>
      <WhenModelValue name='budget_progress' condition={condition}>
        <UI.WithSubtitle
          className='w-1/3 items-center text-center' subtitle={(
            <UI.Text weight='medium' color='black'>
              <Displays.Percentage
                showPlusIfPositive
                decimals={1}
                name='budget_progress'
                badBelow={0}
              />
            </UI.Text>
      )}
        >
          <UI.Text uppercase size='xs' color='gray'>
            <Translation name='generic.budget' />
          </UI.Text>
        </UI.WithSubtitle>
      </WhenModelValue>

      <WhenModelValue name='progress_since_last_month' condition={condition}>
        <UI.WithSubtitle
          className='w-1/3 items-center text-center' subtitle={(
            <UI.Text weight='medium' color='black'>
              <WhenModelValue name='progress_since_last_month' condition={val => val === 'n/a'}>
                N/A
              </WhenModelValue>
              <WhenModelValue name='progress_since_last_month' condition={val => val === 'n/a'} negate>
                <Displays.Percentage
                  showPlusIfPositive
                  decimals={1}
                  name='progress_since_last_month'
                  badBelow={0}
                />
              </WhenModelValue>
            </UI.Text>
      )}
        >
          <UI.Text uppercase size='xs' color='gray'>
            <Translation name='generic.last_month' />
          </UI.Text>
        </UI.WithSubtitle>
      </WhenModelValue>

      <WhenModelValue name='progress_since_last_year' condition={condition}>
        <UI.WithSubtitle
          className='w-1/3 items-center text-center' subtitle={(
            <UI.Text weight='medium' color='black'>
              <Displays.Percentage
                showPlusIfPositive
                decimals={1}
                name='progress_since_last_year'
                badBelow={0}
              />
            </UI.Text>
      )}
        >
          <UI.Text uppercase size='xs' color='gray'>
            <Translation name='generic.last_year' />
          </UI.Text>
        </UI.WithSubtitle>
      </WhenModelValue>

      <WhenModelValue name='production_progress_since_last_year' condition={condition}>
        <UI.WithSubtitle
          className='w-1/3 items-center text-center' subtitle={(
            <UI.Text weight='medium' color='black'>
              <Displays.Percentage
                showPlusIfPositive
                decimals={1}
                name='production_progress_since_last_year'
                badBelow={0}
              />
            </UI.Text>
      )}
        >
          <UI.Text uppercase size='xs' color='gray'>
            <Translation name='generic.last_year' />
            <span> (1:1)</span>
          </UI.Text>
        </UI.WithSubtitle>
      </WhenModelValue>
    </>
  )
}
